export {LoginInfoComponent} from './login-info.component';



// WEBPACK FOOTER //
// ./src/app/shared/user/login-info/index.ts